import SearchEngineAdapter from 'Services/Adapters/SearchEngineBeta/SearchEngineAdapter';
import SalesDocumentsStatus from 'Config/authenticated/SalesDocumentsStatus';
import { v4 as uuidv4 } from 'uuid';

export default class DocumentAdapter extends SearchEngineAdapter {
    /**
     * Define statically the class key
     * Allows to determine the type of class without instantiating it
     */
    static get _key() {
        return 'document';
    }

    constructor(data = [], query = '') {
        super(data, query);
        this.key = DocumentAdapter._key;
        this.secondariesKeys = ['purchase'];
    }

    getStructure() {
        return {
            key: this.key,
            label: window.i18n.__('Document'),
            count: 0,
            items: [],
            groupBy: [
                {
                    key: 'purchase',
                    label: window.i18n.__('Achat'),
                },
                {
                    key: 'document',
                    label: window.i18n.__('Vente'),
                },
                {
                    key: 'redactor',
                    label: window.i18n.__('Redactor'),
                },
            ],
            filters: ['document', 'purchase', 'redactor'],
        };
    }

    extractDataByType() {
        if (!Array.isArray(this.data)) {
            this.data = [this.data];
        }

        if (this.data) {
            return this.data.filter((item) => {
                return (
                    (item.object.type === this.key ||
                        this.secondariesKeys.includes(item.object.type)) &&
                    !item.is_archived
                );
            });
        }
        return [];
    }

    formatItem(item) {
        let link;
        switch (item.object.type) {
            case 'document':
                link = `/?_f=${item.object.sub_type}Overview&id=${item.object.id}`;
                break;
            case 'purchase':
                link = `/?_f=purchases_${item.object.sub_type}Overview&id=${item.object.id}`;
                break;
        }

        return {
            id: item.object.id,
            name: this.checkFieldForQuery(item.name),
            number: this.checkFieldForQuery(item.number),
            object: item.object,
            type: item.object.type,
            sub_type: item.object.sub_type,
            related: {
                name: this.checkFieldForQuery(item.related.name),
                type: item.related.type,
                last_name: this.checkFieldForQuery(item.related.last_name),
                first_name: this.checkFieldForQuery(item.related.first_name),
                link:
                    item.related.type === 'company'
                        ? `/companies/${item.related.id}`
                        : `/individuals/${item.related.id}`,
            },
            status: {
                label: SalesDocumentsStatus[item.object.sub_type][item.status].label,
                id: item.status,
            },
            amount: window.sellsyapp.$filters.numberFormatCurrencyCustomNumberFormat(item.amount, {
                currency: item.currency,
                currencysymbol: item.currency,
            }),
            link,
            component: 'search-result-sales-document',
            uuid: uuidv4(),
            highlightedExtraFields: [
                {
                    label: window.sellsyapp.$t.__('common.labels.external_id') + ' :',
                    value: this.checkFieldForQuery(item.external_number, true),
                },
            ],
        };
    }
}
